import React from 'react';
import { FileText } from 'lucide-react';

export const DefinitionBox = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-200 rounded-3xl p-10 lg:p-12 shadow-lg">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-brand-green/10 rounded-2xl flex items-center justify-center border border-brand-green/15">
                <FileText className="w-8 h-8 text-brand-green" />
              </div>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4 tracking-tight">Was ist ein Unfallgutachten?</h2>
              
              {/* AI-Kurzantwort-Box */}
              <div className="bg-brand-green/5 border-l-4 border-brand-green rounded-r-xl p-5 mb-6">
                <p className="text-sm font-semibold text-brand-green-dark mb-2">Kurz erklärt:</p>
                <p className="text-gray-700 leading-relaxed text-[15px]">
                  Ein Unfallgutachten ist eine unabhängige, fachliche Bewertung eines Unfallschadens. Es dokumentiert Schadenumfang, Reparaturkosten und weitere unfallbedingte Positionen und dient als Grundlage für die Schadenregulierung.
                </p>
              </div>
              
              <p className="text-gray-600 leading-relaxed text-lg mb-4">
                Ein Unfallgutachten ist eine detaillierte, unabhängige Bewertung der Schäden an Ihrem Fahrzeug nach einem Verkehrsunfall. Es dokumentiert objektiv Art und Umfang der Beschädigungen, ermittelt die Reparaturkosten und bewertet eventuelle Wertminderungen.
              </p>
              <p className="text-gray-600 leading-relaxed">
                <strong>Für wen relevant?</strong> Für jeden Geschädigten nach einem unverschuldeten Unfall, bei dem ein Schadenersatzanspruch gegen die gegnerische Versicherung besteht.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};